import { implementService } from '@wix/services-manager/helpers'
import type { ServiceFactoryOpts } from '@wix/services-manager/types'
import { NamedSignalsDefinition } from '@wix/viewer-service-named-signals/definition'
import type { ITestServiceConfig } from '../definitions'
import { TestServiceDefinition } from '../definitions'

export const TestService = implementService(
	TestServiceDefinition,
	({ config, getService }: ServiceFactoryOpts<ITestServiceConfig>) => {
		const signalsService = getService(NamedSignalsDefinition)
		const viewMode = signalsService.signal(config.initialViewMode || 'desktop', 'viewMode')
		return {
			isOpen: (experimentName: string) => Boolean(config.experiments[experimentName]),
			viewMode,
			setViewMode: (newViewMode) => viewMode.set(newViewMode),
		}
	}
)
